import TRANSLATIONS from './json/no_NO_translations.json'

const TRANSLATIONS_NN_NO = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Hold musepekeren over for å zoome',
  'shopping_cart_details.tapToZoom': 'Trykk for å zoome',
  'coupon_code.page_link': 'noOffersPagePresent',
  'order_summary.your_promos' : 'Dine rabattkoder',
  'shopping_cart_details.editImprint': 'Endre trykket',
  'shopping_cart_details.clickToZoom': 'Klikk for å zoome',
  'shopping_cart_details.ships_within_msg': 'Sendes innen [X] virkedager',
  'shopping_cart_details.item_total': 'Totalt:',
  'shopping_cart_details.each': '[X]/stk.',
  'shopping_cart_details.see_more': 'Se Mer',
  'shopping_cart_details.see_less': 'Se Mindre',
  'order_confirmation.cartToOrderFailureMessage' : 'Bestillingen din bekreftes snart.',
  'checkout_payment.paymentErrorTitle': 'Betalingsfeil',
  'checkout_payment.paymentErrorMessage': 'Du kan prøve å oppgi betalingsinformasjonen på nytt. Hvis du fremdeles har problemer, kan du ta kontakt med kundeservice.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Kreditt/Debet',
  'checkout_payment.card_number': 'Kortnummer*',
  'checkout_payment.expiration_mm_yy': 'MM/ÅÅ*',
  'checkout_payment.cvv': 'CCV/CVC*',
  'checkout_payment.name_on_card': 'Kortinnehaver*',
  'checkout_payment.check_cc_try_again': 'Kontroller kortnummeret og prøv på nytt.',
  'checkout_payment.check_date_try_again': 'Kontroller datoen og prøv på nytt.',
  'checkout_payment.check_code_try_again': 'Kontroller koden og prøv på nytt.',
  'checkout_payment.enter_holder_name': 'Oppgi navnet på kortinnehaveren.',
  'checkout_payment.enter_cc_number': 'Oppgi kortnummeret.',
  'checkout_payment.enter_expiration_date': 'Oppgi utløpsdatoen.',
  'checkout_payment.enter_cvv': 'Oppgi sikkerhetskoden (CCV/CVC).',
  'checkout_payment.paypal_pay_later': 'PayPal Betal senere',
  'checkout_payment.continue_will_open_paypal_account_msg': 'Hvis du fortsetter, må du logge på PayPal-kontoen din.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'Hvis du fortsetter, åpnes Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Betal med faktura',
  'checkout_payment.buy_now_pay_later_info_msg': 'Bestill nå, betal senere! Vi sender deg en faktura når bestillingen er sendt.',
  'checkout_payment.learn_more': 'Finn ut mer',
  'checkout_payment.payment_due_late_fee_info_msg': 'Fakturaen må betales ved mottak. Forsinket betaling kan medføre gebyr.',
  'shopping_cart_details.unit': 'enhet',
  'shopping_cart_details.editModalSaving': `Du sparer`,
  'shopping_cart_details.editModalMin_QtyWarning': `Vi beklager, men mengden er ikke tilstrekkelig. Vennligst undersøk hva som er det minste bestillingsantallet. Hvis du ønsker å bestille et lite opplag, kan du kontakte kundeservice.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Vi beklager, men mengden overgår det maksimale bestillingsantallet. Hvis du ønsker å bestille et større opplag, kan du kontakte kundeservice.`,
  'product_details.price':'Pris',
  'product_details.edit_quantity':'Endre antall',
  'myaccount_order_details.seeDetails': 'Mer informasjon',
  'myaccount_order_details.viewOrderDetails': 'Vis bestillingsinformasjonen',
  'myaccount_order_details.payMyInvoice': 'Betal fakturaen',
  'myaccount_order_details.buyItAgain': 'Bestill på nytt',
  'myaccount_order_details.viewImprint': 'Vis trykk',
  'myaccount_order_details.viewArtwork': 'Vis designet',
  'myaccount_order_details.productDetails': 'Produktinformasjon',
  'myaccount_order_details.orders': 'bestillinger',
  'my_account_order_details.shipping_and_billing_addresses': 'Leverings- og faktureringsadresser',
  'my_account_order_details.log_in_to_view' : 'Logg inn for mer informasjon',
  'error.use_of_old_password': 'Passordet må være ulikt de siste fem passordene.',
  'order_confirmation.postCheckout_signIn':`Logg inn for å få flere fordeler`,
  'order_confirmation.postCheckout_accountCreation':'Opprett konto for å få flere fordeler',
  'order_confirmation.postCheckout_trackOrder':'Følg bestillingen din',
  'order_confirmation.would_you_like_to':'Få gode tilbud og gratisprøver når du melder deg på e-poster og SMS-tilbud fra Pens.com!',
  'order_confirmation.sign_up.contact_agreement1':'Ja',
  'order_confirmation.sign_up.contact_agreement2':', takk, jeg elsker gode tilbud!',
  'order_confirmation.sign_up.contact_disagreement1':'Nei',
  'order_confirmation.sign_up.contact_disagreement2':', takk!',
  'create_account.title':'Opprett konto',
  'order_confirmation.sign_in.title':'Logg deg inn på kontoen din',
  'order_confirmation.my_acc.title':'Min konto',
  'order_confirmation.addPassword':'Legg til et passord:',
  'order_confirmation.accountCreated':'Kontoen ble opprettet',
  'myaccount_address_list.shippingAddresses': 'Leveringsadresse',
  'myaccount_address_list.billingAddresses': 'Fakturaadresse',
  'myaccount_address_list.defaultAddress': 'Standardadresse',
  'myaccount_address_list.setDefault': 'Merk som standard',
  'myaccount_delete_address.delete_confirmation': 'Bekreftelse på sletting',
  'myaccount_delete_address.confirmation_message': 'Er du sikker på at du vil slette denne adressen?',
  'myaccount_delete_address.delete_address': 'Slett adressen',
  'myaccount_delete_address.delete': 'Slett',
  'myaccount_error_new_password.complexity':"Nye passord må inneholde: et tall, et spesialtegn [!#$%&'*+-/=?^_`{|}~.@] og store og små bokstaver.",
  'myaccount_error_confirm_password.complexity':"Bekreftet passord må inneholde: et tall, et spesialtegn [!#$%&'*+-/=?^_`{|}~.@] og store og små bokstaver.",
  'myaccount_error_new_password.common_password':'Det nye passordet kan ikke være det samme som e-postadressen din.',
  'myaccount_error_confirm_password.common_password':'Det bekreftede passordet kan ikke være det samme som e-postadressen din.',
  'myaccount.change_personal_information.change_password_info' : 'Du blir logget av alle aktive enheter.',
  'validation.password_validation_heading' : 'Passordet må bestå av:',
  'validation.password_validation_uppercase' : 'minst én stor bokstav',
  'validation.password_validation_lowercase' : 'minst én liten bokstav',
  'validation.password_validation_symbol' : 'minst ett spesialtegn',
  'validation.password_validation_number' : 'minst ett nummer',
  'validation.password_validation_length' : 'Minst 8 tegn',
  'validation.password_validation_match' : 'Passordene må være like',
  'validation.password_min_characters': 'Passordet må ha minst åtte tegn.',
  'myaccount_password_settings.heading' : 'Passordinnstilling',
  'myaccount_password_settings.newPassword' : 'Nytt passord',
  'myaccount_password_settings.confirmPassword' : 'Bekreft passord',
  'myaccount_password_settings.updatePassword' : 'Oppdater passord',
  'myaccount_password_settings.createPassword' : 'Opprett passord',
  'myaccount_password_settings.use_of_old_password': 'Passordet må være ulikt de siste fem passordene.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'shopping_bag.expired_discount_coupon':'Rabattkoden du oppga, er ikke lenger gyldig. Prøv en annen rabattkode.',
  'shopping_bag.invalid_discount_coupon':'Rabattkoden du oppga, er ikke lenger gyldig. Prøv en annen rabattkode.',
  'order_summary.oops_error': 'Ops! Det har oppstått en feil hos oss! Vennligst prøv på nytt.',
  'order_summary.one_promo_at_a_time': 'Du kan kun bruke én rabattkode av gangen.',
  'order_summary.code_applied': 'Koden ble brukt',
  'order_summary.change_promo': 'Endre rabattkode',
  'order_summary.your_promo_code': 'Dine rabattkoder',
  'order_summary.no_items_eligible': 'Rabattkoden du oppga, kan ikke bruke på noen av varene i handlevognen din.',
  'order_details.production_time_begin_msg': '*Produksjonstiden beregnes fra det tidspunktet bestillingen er bekreftet og designet godkjent',
  'order_details.reorder_tat': 'Når du bestiller på nytt, sendes pakken innen X virkedager*',
  'dashboard.edit' : 'Rediger',
  'dashboard.greeting':'Hei!',
  'myaccount_personal_info.save_changes' : 'Lagre endringer',
  'myaccount_personal_info.cancel' : 'Avbryt',
  'myaccount_personal_info.name_title' : 'Navn',
  'myaccount_personal_info.password_title' : 'Passord',
  'myaccount_personal_info.add_name' : 'Legg inn navn',
  'myaccount_personal_info.edit_name' : 'Endre navn',
  'myaccount_personal_info.name_updated' : 'Navnet ble endret.',
  'myaccount.something_went_wrong': 'Det oppsto en feil. Vennligst prøv på nytt.',
  'checkout.reorder.buy_it_again':'Bestill på nytt',
  'checkout.reorder.purchased':'Kjøpt',
  'checkout.reorder.last_qty':'Sist bestilte antall',
  'checkout.reorder.ships_within_msg':'Sendes innen [X] virkedager',
  'checkout.reorder.add_to_cart': 'Legg i handlevognen',
  'shopping_cart_details.add_accessory': 'Legg til tilbehør',
  'oos.item_out_of_stock': 'Denne varen er for øyeblikket utsolgt.',
  'oos.view_similar': 'Vis liknende produkter',
  'oos.similar_products': 'Lignende produkter',
  'oos.remove_out_of_stock_items': 'Beklager, men du må fjerne varene som ikke lenger finnes på lager fra handlevognen din.',
  'oos.one_or_more_items_removed_from_cart': 'En eller flere av størrelsene er ikke lenger på lager. Vi har fjernet dem fra listen.',
  'oos.go_back_to_review': 'Gå tilbake til handlevognen for å se gjennom varene.',
  'oos.go_back_to_remove': 'Gå tilbake til handlevognen for å fjerne produktet.',
  'oos.out_of_stock': 'Utsolgt',
  'shopping_cart_details.add_amount': 'Legg til [X] for å benytte deg av tilbudet.',
  'import_charge_title':'Importavgift',
  'import_charge_description': 'De nylig etablerte importavgiftene har påvirket produktprisene våre. Vi arbeider hard for å redusere påvirkningen av denne prisøkningen på kundene våre.',
  'gdpr.heading' : 'Kontoen ble opprettet – velkommen!',
  'gdpr.subheading' : 'Kontoen din har blitt opprettet ved hjelp av e-postadressen:',
  'gdpr.promotion': 'Få spesialrabatter og gratisprøver ved å melde deg på e-posttilbudene fra Pens.com!',
  'gdpr.yesDeal' : 'Ja, takk, jeg elsker gode tilbud',
  'gdpr.noDeal' : 'Nei, takk.',
  'gdpr.button' : 'Fortsette',
  'new_activation.head' : 'Sjekk e-posten din!',
  'new_activation.sub_head' : 'Hei!',
  'new_activation.main_body1' : 'Takk for at du har registrert deg hos Pens.com',
  'new_activation.main_body2' : 'En aktiveringslink ble sendt til din registrerte epost-adresse',
  'new_activation.main_body3' : 'Du kan ikke logge inn før kontoen din har blitt aktivert. Vennligst klikk på aktiveringslinken for å aktivere kontoen din.',
  'myaccount_personal_info.password_not_set' : 'Du har ikke angitt passord for denne kontoen.',
  'myaccount_personal_info.click_here' : 'Klikk her',
  'myaccount_personal_info.to_reset_password' : 'for å opprette et passord.',
  'myaccount_personal_info.note' : 'Merk: Denne handlingen logger deg av hvis du er pålogget.',
  'moq.lineItem_warning': 'Antallet i bestillingen er under minsteantallet for denne varen.',
  'moq.edit_qantity_link_text': 'Velg et annet antall.',
  'moq.cart_level_warning': 'Oppdater bestillingens antall for å fullføre betalingen.',
  'moq.go_back_to_cart': 'Gå tilbake til handlevognen, og oppdater antallet',
  ...TRANSLATIONS
};
export default TRANSLATIONS_NN_NO;